import React from 'react';
import { Box, BoxProps, Typography } from '@mui/material';

interface Props extends BoxProps {
  title?: string;
}

const PageHeader: React.FC<Props> = (props) => {
  const { children, title, ...rest } = props;
  return (
    <Box display="flex" gap="8px" mb={5} mt={8} {...rest}>
      {title && (
        <Typography variant="h2" color="grey.100" mr="auto">
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default PageHeader;
